import React, { useState } from "react";
import Title from "./Title";
import FirstPayment from "./FirstPayment";
import PaymentMethod from "./PaymentMethod";
import { useTranslation } from "../../context/TranslationContext";

const PaymentOptions = ({ reservationResult, paymentType }) => {  
  const { reservationSection2Title } = useTranslation();

  return (
    <div className="mt-24">
      <Title>{reservationSection2Title}</Title>
      <div className="mt-5 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)]">
          <FirstPayment reservationResult={reservationResult} payment_type={paymentType} />
          <PaymentMethod />
      </div>
    </div>
  );
};

export default PaymentOptions;
